(function(api) {
	api.PartnerById = PartnerById;
	api.PostaById = PostaById;
	api.PostaByNaziv = PostaByNaziv;
	api.GetPrviZiroRacun = GetPrviZiroRacun;
	api.GetNoviPartner = GetNoviPartner;
	api.ParOsobaById = ParOsobaById;
	api.PartnerFizickaByOIB = PartnerFizickaByOIB;
	api.PartnerPravnaByOIB = PartnerPravnaByOIB;
    api.PartnerByPravniOblikOIB = PartnerByPravniOblikOIB;
    api.KreirajPartneraSap = KreirajPartneraSap; 
	api.TecajObrisi = TecajObrisi;
	api.TecajSkupnoPitanje = TecajSkupnoPitanje;
	api.MailTest = MailTest;
	api.NaseljePredlozi = NaseljePredlozi; //na temelju poste
	api.PredloziSifruNaselja = PredloziSifruNaselja; //na temelju opcine
	api.OpaskaNextRedniBroj = OpaskaNextRedniBroj;
	api.ZOsobaById = ZOsobaById;
	api.TecajVrstaObrisi = TecajVrstaObrisi;
	api.PomocByPoziv = PomocByPoziv;
	api.PomocById = PomocById;
	api.GetPomocVerzija = GetPomocVerzija;	
	api.GetPomocVideoVerzija = GetPomocVideoVerzija;	
	api.LokacijaJeZupanija = LokacijaJeZupanija;
	api.OrganImaFilterOznake = OrganImaFilterOznake;
	api.PdvById = PdvById;
	api.GetParOsobaTelFields = GetParOsobaTelFields;
	api.GetParOsobaTelefon = GetParOsobaTelefon;
	api.ParOsobaTelObrisi = ParOsobaTelObrisi;
	api.PretvoriTelefonskiBrojUBroj64 = PretvoriTelefonskiBrojUBroj64;
	api.PredloziZaZPartnera = PredloziZaZPartnera;
	api.PredloziJezikZaDrzava = PredloziJezikZaDrzava;
	api.GetBarkodHUB3 = GetBarkodHUB3;
	api.PartnerProvjeriVAT = PartnerProvjeriVAT;
	api.GetPartnerInfo = GetPartnerInfo;
	api.GetPartnerNaziv = GetPartnerNaziv;	
	api.GetPartnerBiljeskaEK = GetPartnerBiljeskaEK;
	api.IzmijeniPartnerBiljeskaEK = IzmijeniPartnerBiljeskaEK;
	api.GetClanicaEULabelCaption = GetClanicaEULabelCaption;
	api.DohvatiPitanjeAfterDrzavaSifra = DohvatiPitanjeAfterDrzavaSifra;
	api.DohvatiPitanjeAfterIDrzavaSifra = DohvatiPitanjeAfterIDrzavaSifra;
	api.GetEUPDVPrefixIliOznaka2 = GetEUPDVPrefixIliOznaka2;
	api.ZiroPomak = ZiroPomak;	
	api.ZiroObrisi = ZiroObrisi;
	api.ZiroGetDetalji = ZiroGetDetalji; //dohvaca podatke o Shemi, VDBI, Broju racuna i IBAN
	api.ZiroZRuIBAN = ZiroZRuIBAN;
	api.ZiroGetSwiftBanke = ZiroGetSwiftBanke; 
	api.GetPartnerInozemni = GetPartnerInozemni;
	api.ZiroCBBankaPartnerValidate = ZiroCBBankaPartnerValidate;
	api.ZiroVDBIWarrning = ZiroVDBIWarrning;
	api.ZiroRacunIstiInteract = ZiroRacunIstiInteract;
	api.ZiroRacunLosWarrning = ZiroRacunLosWarrning;
	api.ZiroGetVBDI = ZiroGetVBDI;
	api.ZiroBeforeUpisiAllWarrning = ZiroBeforeUpisiAllWarrning;
	api.SetAfterZiro = SetAfterZiro;
	api.GetDatumNakonXRadnihDana = GetDatumNakonXRadnihDana;
	api.UcitajTecaj = UcitajTecaj;
	api.GetPartnerAdresaIsporukeByOrgan = GetPartnerAdresaIsporukeByOrgan;
	api.GetPartnerAdresaIsporuke = GetPartnerAdresaIsporuke;
	api.GetOznakaObjekta = GetOznakaObjekta;
	api.GetPartnerIParOsobaByKartica = GetPartnerIParOsobaByKartica;	
	api.ParOsobaGetNaziv = ParOsobaGetNaziv;
	api.ProvjeriOib = ProvjeriOib;
	api.ProvjeriPodruznica = ProvjeriPodruznica;
	api.GetOdgodaDobavljac = GetOdgodaDobavljac;	
	api.GetTecajNaDan = GetTecajNaDan;	
	api.GetTecajNaDanSParitetom = GetTecajNaDanSParitetom;	
	api.CpvObrisi = CpvObrisi;
	api.SetAfterCpv = SetAfterCpv;
	api.OrganProsirenoById = OrganProsirenoById;	
	api.OrganBezOvlProsirenoById = OrganBezOvlProsirenoById;	
	api.GetDanUTjednu = GetDanUTjednu;
	api.DajPopisParOsoba = DajPopisParOsoba;
	api.GetNotifikacija = GetNotifikacija;	
	api.GetBrojNotifikacija = GetBrojNotifikacija;
	api.NotifikacijaProcitana = NotifikacijaProcitana;		
	api.NotifikacijeProcitane = NotifikacijeProcitane;
	api.ParOsobaTelSetAfterBroj = ParOsobaTelSetAfterBroj;	
	api.ZOsobaLogFields = ZOsobaLogFields;
	api.ZOsobaCertZaOsobuFields = ZOsobaCertZaOsobuFields;	
	api.GetKontoKorisnikIzPoduzeca = GetKontoKorisnikIzPoduzeca;
	api.PostaviCertParam  = PostaviCertParam;	
	api.DecodeCertLoz  = DecodeCertLoz;
	api.ZOsobaCertPomak = ZOsobaCertPomak;
	api.DeaktivirajCertifikat = DeaktivirajCertifikat;
	api.MTroskaById = MTroskaById;
	api.MTroskaBezOvlById = MTroskaBezOvlById;
	api.MTroskaProsirenoById = MTroskaProsirenoById;
	api.OrganById = OrganById;
	api.OrganBezOvlById = OrganBezOvlById;
	api.PartnerSviByOIBCarina = PartnerSviByOIBCarina;
	api.TestPotpisaSoft = TestPotpisaSoft;		
	api.DohvatiTestDatotekuZaPotpis = DohvatiTestDatotekuZaPotpis;
	api.DownloadFileFromDPObject = DownloadFileFromDPObject;	
	api.GetStudentNazivZaCert = GetStudentNazivZaCert;	
	api.ParOsobaResetLozinke = ParOsobaResetLozinke;
	api.ZbrojniSCopy = ZbrojniSCopy;
	api.ZbrojniSPaste = ZbrojniSPaste;
	api.ZbrojniPromjenaStatusa = ZbrojniPromjenaStatusa;
	api.GetZbrojniZakljucan = GetZbrojniZakljucan;
	api.ZbrojniSObrisiList = ZbrojniSObrisiList;
	api.ZbrojniImaStavke = ZbrojniImaStavke;
	api.ZbrojniObrisiZbrojniIliStavke = ZbrojniObrisiZbrojniIliStavke;
	api.GetZbrojniBrisanjePitanje = GetZbrojniBrisanjePitanje;
	api.GetZbrojniBrisanjeDodatnoPitanje = GetZbrojniBrisanjeDodatnoPitanje;						
	api.ZbrojniSSetAfterPolje = ZbrojniSSetAfterPolje;
	api.GetHRValutaTekstualnoUOdgPadezuZaGodinu = GetHRValutaTekstualnoUOdgPadezuZaGodinu;	
	api.ZbrojniFormiratiXMLDatoteku = ZbrojniFormiratiXMLDatoteku;
	api.ZbrojniPrijenos = ZbrojniPrijenos;
	api.ZbrojniMogucPrijenos = ZbrojniMogucPrijenos;
	api.ZbrojniMogucPrijenosValidacija = ZbrojniMogucPrijenosValidacija;	
	api.ZbrojniPrijenosSetAfterPolje = ZbrojniPrijenosSetAfterPolje;
	api.PartnerSinkronizacija = PartnerSinkronizacija;
					
	function PartnerSviByOIBCarina(oib){
		return $.dsDirectCall({
			method: "sf/PartnerSviByOIBCarina",
			params: [oib]
		});
	}

	api.KreirajIzvorniJop = KreirajIzvorniJop;	
	api.KreirajIspravakJopa = KreirajIspravakJopa;
	api.KreirajDopunuJopa = KreirajDopunuJopa;
	api.KreirajXmlJopa = KreirajXmlJopa;
	//api.SetObjectAfterRadnikJop = SetObjectAfterRadnikJop;
	api.JopSSetAfterPolje = JopSSetAfterPolje;
	api.MozeNoviJopS = MozeNoviJopS;
	api.KopirajJop = KopirajJop;
		
	api.GetZbrojniSFields = GetZbrojniSFields;			
		
	function GetNotifikacija(){
		return $.dsDirectCall({
			method: "sf/GetNotifikacija",
			errorOverride: true,
			sessionExpired: function(data, textStatus, jqXHR){}
		});
	}

	function GetBrojNotifikacija(){
		return $.dsDirectCall({
			method: "sf/GetBrojNotifikacija",
			errorOverride: true,
			sessionExpired: function(data, textStatus, jqXHR){}
		});
	}

	function NotifikacijaProcitana(id){
	    return $.dsDirectCall({
			method: "sf/NotifikacijaProcitana",
			params: [id]
	    });
	}

	function NotifikacijeProcitane(){
	    return $.dsDirectCall({
			method: "sf/NotifikacijeProcitane"		
	    });
	}

	function PartnerById(partner){
	    return $.dsDirectCall({
		    method: "sf/PartnerById",
		    params: [ partner ]
	    });
	}
	
	function PostaById(posta, drzava){
		if (drzava == undefined) drzava = '';
	    return $.dsDirectCall({
		    method: "sf/PostaById",
		    params: [ posta, drzava ]
	    });
	}
	
	function PostaByNaziv(mjesto){
		return $.dsDirectCall({
			method: "sf/PostaByNaziv",
			params: [ mjesto ]
		});
	}
	
	function GetPrviZiroRacun(partner){
		return $.dsDirectCall({
            method: "sf/GetPrviZiroRacun",
            params: [ partner ]			
		});
	}
	
	function GetNoviPartner(generator){
		return $.dsDirectCall({
			method: "sf/GetNoviPartner",
			params: [ generator ]
		});		
	}
	
	function ParOsobaById(partner, parOsoba){
		return $.dsDirectCall({
			method: "sf/ParOsobaById",
            params: [	partner, parOsoba ]
     	});
	}
	
	function ParOsobaResetLozinke(partner, parOsoba){
		return $.dsDirectCall({
			method: "sf/ParOsobaResetLozinke",
            params: [	partner, parOsoba ]
     	});
	}
	
	function PartnerFizickaByOIB(oib){
		return $.dsDirectCall({
			method: "sf/PartnerFizickaByOIB",
			params: [ oib ]
		});
	}
	
	function PartnerPravnaByOIB(oib){
		return $.dsDirectCall({
			method: "sf/PartnerPravnaByOIB",
			params: [ oib ]
		});
	}
	
	function PartnerByPravniOblikOIB(pravniOblik, oib){
        return $.dsDirectCall({
            method: "sf/PartnerByPravniOblikOIB",
            params: [ pravniOblik, oib ]
        });
    }

    function KreirajPartneraSap(partner){
        return $.dsDirectCall({
            method: "sf/KreirajPartneraSap",
            params: [ partner ]
        });
    }    
	
	function TecajObrisi(tecajid){
		return $.dsDirectCall({
			method: "sf/TecajObrisi",
			params: [ tecajid ]
		});
	}
	
	function TecajSkupnoPitanje(datum1, datum2, novi){
	    return $.dsDirectCall({
		    method: "sf/TecajSkupnoPitanje",
		    params: [ datum1, datum2, novi ]
	    });
	}
	
	function MailTest(mailTo, mailSubject){
		return $.dsDirectCall({
			method: "sf/MailTest",
			params: [ mailTo, mailSubject ]
		});
	}
	
	function NaseljePredlozi(posta){
		return $.dsDirectCall({
			method: "sf/NaseljePredlozi",
			params: [ posta ]
		});
	}
	
	function PredloziSifruNaselja(sifopcina){
		return $.dsDirectCall({
			method: "sf/PredloziSifruNaselja",
			params: [ sifopcina ] 
		});
	}
	
	function OpaskaNextRedniBroj(opaska){
		return $.dsDirectCall({
			method: "sf/OpaskaNextRedniBroj",
			params: [ opaska ]
		});
	}
	
	function ZOsobaById(zOsoba){
		return $.dsDirectCall({
			method: "sf/ZOsobaById",
			params: [ zOsoba ]
		});
	}
	
	function TecajVrstaObrisi(tecajVrsta){
		return $.dsDirectCall({
			method: "sf/TecajVrstaObrisi",
			params: [ tecajVrsta ]
		});
	}
	
	function PdvById(pdv){
		return $.dsDirectCall({
			method: "sf/PdvById",
			params: [ pdv ]
		});
	}
	
	function PomocByPoziv(projekt, poziv, verzija){
		return $.dsDirectCall({
			method: "sf/PomocByPoziv",
			params: [ projekt, poziv, verzija]
		});	
	}
	
	function PomocById(pomoc){
		return $.dsDirectCall({
			method: "sf/PomocById",
			params: [ pomoc ]
		});
	}
	
	function GetPomocVerzija(verzija, prog, progver){
		if (verzija == undefined) verzija = 0;
		if (prog == undefined) prog = '';
		return $.dsDirectCall({
			method: "sf/GetPomocVerzija",
			params: [verzija, prog, progver]	
		});
	}

	function GetPomocVideoVerzija(verzija, prog){
		if (verzija == undefined) verzija = 0;
		if (prog == undefined) prog = '';
		return $.dsDirectCall({
			method: "sf/GetPomocVideoVerzija",
			params: [verzija, prog]	
		});
	}
	
	function LokacijaJeZupanija(lokac){
		return $.dsDirectCall({ 
			method: "sf/LokacijaJeZupanija",
			params: [lokac]
		});	
	}
	
	function OrganImaFilterOznake(){
		return $.dsDirectCall({ 
			method: "sf/OrganImaFilterOznake",
		});
	}
	
	function GetParOsobaTelFields(partner, parOsoba){
		return $.dsDirectCall({
			method: "sf/GetParOsobaTelFields",
			params: [ partner, parOsoba]
		});
	}
	
	function GetParOsobaTelefon(partner, parOsoba){
		return $.dsDirectCall({
			method: "sf/GetParOsobaTelefon",
			params: [ partner, parOsoba]
		});
	}
	
	function ParOsobaTelObrisi(parOsobaTel){
		return $.dsDirectCall({
			method: "sf/ParOsobaTelObrisi",
			params: [ parOsobaTel ]	
		});
	}
	
	function PretvoriTelefonskiBrojUBroj64(broj){
		return $.dsDirectCall({
			method: "sf/PretvoriTelefonskiBrojUBroj64",
			params: [ broj ]
		});
	}
	
	function ParOsobaTelSetAfterBroj(broj){
		return $.dsDirectCall({
			method: "sf/ParOsobaTelSetAfterBroj",
			params: [ broj ]
		});
	}
	
	function PredloziZaZPartnera(zPartner){
		if (zPartner == undefined) zPartner = 0;
		return $.dsDirectCall({
			method: "sf/PredloziZaZPartnera",
			params: [ zPartner ]
		});
	}
	
	function PredloziJezikZaDrzava(drzava){
		return $.dsDirectCall({
			method: "sf/PredloziJezikZaDrzava",
			params: [ drzava ]
		});
	}
	
	function GetBarkodHUB3(barkod){
		return $.dsDirectCall({
			method: "sf/GetBarkodHUB3",
			params: [barkod]
		});
	}	
	
	//provjerava na objektu Partner (bitno je zbog toga jer je u Partner.Biljeska upisuje rezultat)
	function PartnerProvjeriVAT(partner, drzava, OIB, biljeska){
		return $.dsDirectCall({
			method: "sf/PartnerProvjeriVAT",
			params: [partner, drzava, OIB, biljeska]
		});
	}	
	
	function GetPartnerInfo(partnerId){
		return $.dsDirectCall({ 
	        method: "sf/GetPartnerInfo",
	        params: [partnerId]
	    });
	}
	
	function GetPartnerNaziv(partnerId){
		return $.dsDirectCall({ 
	        method: "sf/GetPartnerNaziv",
	        params: [partnerId]
	    });
	}
	
	function GetPartnerBiljeskaEK(partnerId){
		return $.dsDirectCall({
            method: "sf/GetPartnerBiljeskaEK",
            params: [partnerId]
     	});
	}
	
	function IzmijeniPartnerBiljeskaEK(data) {
		return $.dsDirectCallPost({
			method: "IzmijeniPartnerBiljeskaEK",
			controller: "partner",
			data: [data]
		});			
	}

	function GetClanicaEULabelCaption(drzavaId, inozemni){
		return $.dsDirectCall({
			method: "sf/GetClanicaEULabelCaption",
			params: [drzavaId, inozemni]
		});
	}
	
	function DohvatiPitanjeAfterDrzavaSifra(drzavaId){
		return $.dsDirectCall({
			method: "sf/DohvatiPitanjeAfterDrzavaSifra",
			params: [drzavaId]
		});
	}
	
	function DohvatiPitanjeAfterIDrzavaSifra(drzavaId){
		return $.dsDirectCall({
			method: "sf/DohvatiPitanjeAfterIDrzavaSifra",
			params: [drzavaId]
		});
	}
	
	function GetEUPDVPrefixIliOznaka2(drzavaId){
		return $.dsDirectCall({
			method: "sf/GetEUPDVPrefixIliOznaka2",
			params: [drzavaId]
		});
	}
	
	function ZiroPomak(partner, redni, pomak, noviPartner){
		noviPartner = (typeof noviPartner !== 'undefined') ? noviPartner : false;
		return $.dsDirectCall({
			method: "sf/ZiroPomak",
			params: [partner, redni, pomak, noviPartner]
		});	
	}
	
	function ZiroObrisi(partner, redni, transakcija, presloziPoredak, noviPartner){
		noviPartner = (typeof noviPartner !== 'undefined') ? noviPartner : false;
		return $.dsDirectCall({
			method: "sf/ZiroObrisi",
			params: [ partner, redni, transakcija, presloziPoredak, noviPartner ]
		});
	}
	
	function ZiroGetDetalji(partner, ziro, bankaPartner){
		return $.dsDirectCall({
			method: "sf/ZiroGetDetalji",
			params: [ partner, ziro, bankaPartner ]
		});
	}
	
	function ZiroZRuIBAN(ziro){
		return $.dsDirectCall({
			method: "sf/ZiroZRuIBAN",
			params: [ ziro ]
		});
	}
	
	function ZiroGetSwiftBanke(bankaPartner){
		return $.dsDirectCall({
			method: "sf/ZiroGetSwiftBanke",
			params: [ bankaPartner ]
		});
	}
	
	function GetPartnerInozemni(partner){
		return $.dsDirectCall({
			method: "sf/GetPartnerInozemni",
			params: [ partner ]			
		});
	}
	
	function ZiroCBBankaPartnerValidate(bankaJePartner, novi, ciPartner, poredak, bankaPartner){
		return $.dsDirectCall({
			method: "sf/ZiroCBBankaPartnerValidate",
			params: [ bankaJePartner, novi, ciPartner, poredak, bankaPartner ]
		});
	}
	
	function ZiroVDBIWarrning(ciPartner, bankaPartner, VBDI, novi){
		return $.dsDirectCall({
			method: "sf/ZiroVDBIWarrning",
			params: [ ciPartner, bankaPartner, VBDI, novi ]
		});
	}
	
	function ZiroRacunLosWarrning(ziroRacun, ciPartner, ciBankaPartner){
		return $.dsDirectCall({
			method: "sf/ZiroRacunLosWarrning",
			params: [ ziroRacun, ciPartner, ciBankaPartner ]
		});
	}
	
	function ZiroRacunIstiInteract(ziro, partner){
		return $.dsDirectCall({
			method: "sf/ZiroRacunIstiInteract",
			params: [ ziro, partner ]			
		});
	}
	
	function ZiroGetVBDI(partner, redni, gledajPoredakUmjestoRedni){
		return $.dsDirectCall({
			method: "sf/ZiroGetVBDI",
			params: [ partner, redni, gledajPoredakUmjestoRedni ]			
		});	
	}
	
	//�alje se objekt
	function ZiroBeforeUpisiAllWarrning(ziro, novi){
		return $.dsDirectCall({
			method: "sf/ZiroBeforeUpisiAllWarrning",
			params: [ ziro, novi ]			
		});		
	}	
	
	function SetAfterZiro(ziro){
		return $.dsDirectCall({
			method: "sf/SetAfterZiro",
			params: [ ziro ]	
		});
	}

	function GetDatumNakonXRadnihDana(datumPocetka, brojRadnihDana){
		return $.dsDirectCall({
			method: "sf/GetDatumNakonXRadnihDana",
			params: [ datumPocetka, brojRadnihDana ]	
		});
	}
	
	function GetOznakaObjekta() {		
		return $.dsDirectCall({
			method: "sf/GetOznakaObjekta"
		});	
	}	

	function UcitajTecaj(banka, tecajVrsta, datumOd, datumDo, dodajNoveValute, glavniTecaj, moguceValute, valute) {
		return $.dsDirectCall({
            method: "sf/UcitajTecaj",
            params: [banka, tecajVrsta, datumOd, datumDo, dodajNoveValute, glavniTecaj, moguceValute, valute]
     	});
	}
	
	function GetPartnerAdresaIsporukeByOrgan(organ){
		return $.dsDirectCall({
			method: "sf/GetPartnerAdresaIsporukeByOrgan",
			params: [ organ ]
		});
	}
	
	function GetPartnerAdresaIsporuke(partner){
		return $.dsDirectCall({
			method: "sf/GetPartnerAdresaIsporuke",
			params: [ partner ]
		});
	}
		
	function ProvjeriOib(partner){
		return $.dsDirectCallPost({
			method: "ProvjeriOib",
			controller: "partner",
			data: [ partner ]
		});	
	}
	
	function ProvjeriPodruznica(partner){
		return $.dsDirectCallPost({
			method: "ProvjeriPodruznica",
			controller: "partner",
			data: [ partner ]
		});	
	}
	

	function GetPartnerIParOsobaByKartica(kartica){
		return $.dsDirectCall({
			method: "sf/GetPartnerIParOsobaByKartica",
			params: [ kartica ]
		});
	}
	
	function ParOsobaGetNaziv(partner, parOsoba){
		return $.dsDirectCall({
			method: "sf/ParOsobaGetNaziv",
			params: [ partner, parOsoba ]
		});
	}
	
	function GetOdgodaDobavljac(partner){
		return $.dsDirectCall({
			method: "sf/GetOdgodaDobavljac",
			params: [ partner ]
		});
	}
	
	function GetTecajNaDan(tecajvrsta, valuta, datum) { 
		return $.dsDirectCall({ 
			method: "sf/GetTecajNaDan", 
			params: [tecajvrsta, valuta, datum]
		});   
	}

	function GetTecajNaDanSParitetom(tecajvrsta, valuta, datum) { 
		return $.dsDirectCall({ 
			method: "sf/GetTecajNaDanSParitetom", 
			params: [tecajvrsta, valuta, datum]
		});   
	}
	
	function IntraArtiklUcitajPotrebnoIzNadredene(ISN){
		return $.dsDirectCall({ 
			method: "sf/IntraArtiklUcitajPotrebnoIzNadredene", 
			params: [ISN]
		}); 		
	}
	
	function CpvObrisi(cpv){
		return $.dsDirectCall({ 
			method: "sf/CpvObrisi", 
			params: [ cpv ]
		}); 		
	}
	
	function SetAfterCpv(cpv){
		return $.dsDirectCall({ 
			method: "sf/SetAfterCpv", 
			params: [ cpv ]
		}); 		
	}
	
	function OrganProsirenoById(organ){
		return $.dsDirectCall({
			method: "sf/OrganProsirenoById",
			params: [ organ ]
		});
	}
	
	function OrganBezOvlProsirenoById(organ){
		return $.dsDirectCall({
			method: "sf/OrganBezOvlProsirenoById",
			params: [ organ ]
		});
	}

	function GetDanUTjednu(datum){
		return $.dsDirectCall({
			method: "sf/GetDanUTjednu",
			params: [ datum ]
		});
	}
	
	function DajPopisParOsoba(partner, prikaziNeaktivne) {
		return $.dsDirectCall({
			method: "sf/DajPopisParOsoba",
			params: [ partner, prikaziNeaktivne ]
		});
	}
	
  	function ZOsobaLogFields(zosoba){
  		return $.dsDirectCall({
  			method: "sf/ZOsobaLogFields",
			params: [ zosoba ]  			
  		});
  	}

  	function ZOsobaCertZaOsobuFields(zosoba){
  		return $.dsDirectCall({
  			method: "sf/ZOsobaCertZaOsobuFields",
			params: [ zosoba ]  			
  		});
  	}
	
  	function GetKontoKorisnikIzPoduzeca(korisnik){	
  		return $.dsDirectCall({
  			method: "sf/GetKontoKorisnikIzPoduzeca",
			params: [ korisnik ]  			
  		});
  	}
	
	function PostaviCertParam(index, certLoz){  		
  		return $.dsDirectCall({
  			method: "sf/PostaviCertParam",
			params: [ index, certLoz]  			
  		});
  	}

	function DecodeCertLoz(certLoz){  		
  		return $.dsDirectCall({
  			method: "sf/DecodeCertLoz",
			params: [ certLoz]  			
  		});
  	}
  		
	function ZOsobaCertPomak(zosoba, zosobacert, pomak, noviZOsobaCert){
		noviZOsobaCert = (typeof noviZOsobaCert !== 'undefined') ? noviZOsobaCert : false;
		return $.dsDirectCall({
			method: "sf/ZOsobaCertPomak",
			params: [zosoba, zosobacert, pomak, noviZOsobaCert]
		});	
	}
  		
	function DeaktivirajCertifikat(zosobacert) { 
		return $.dsDirectCall({ 
			method: "sf/DeaktivirajCertifikat", 
			params: [ zosobacert ]
		});  
	}
    function MTroskaById(mtroska){
	    return $.dsDirectCall({
		    method: "sf/MTroskaById",
		    params: [ mtroska ]
	    });
	}
	
    function MTroskaBezOvlById(mtroska){
	    return $.dsDirectCall({
		    method: "sf/MTroskaBezOvlById",
		    params: [ mtroska ]
	    });
	}

	function MTroskaProsirenoById(mtroska){
	    return $.dsDirectCall({
		    method: "sf/MTroskaProsirenoById",
		    params: [ mtroska ]
	    });
	}
	
    function OrganById(organ){
	    return $.dsDirectCall({
		    method: "sf/OrganById",
		    params: [ organ ]
	    });
	}
	
    function OrganBezOvlById(organ){
	    return $.dsDirectCall({
		    method: "sf/OrganBezOvlById",
		    params: [ organ ]
	    });
	}

	function TestPotpisaSoft(obj, errorOverride) { 
		return $.dsDirectCallPost({
            method: "TestPotpisaSoft",
            controller: "ZOsoba",
            params: [ ],
			data: [ obj ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}            
        });
	}	

	function DohvatiTestDatotekuZaPotpis(obj, errorOverride) { 
		return $.dsDirectCallPost({
            method: "DohvatiTestDatotekuZaPotpis",
            controller: "ZOsoba",
            params: [ ],
			data: [ obj ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}            
        });
	}		
	
	function DownloadFileFromDPObject(url, obj, errorOverride) { 
        $.fileDownload(url, {
            httpMethod: "POST",
            data: obj,
            prepareCallback: function (url) {
                dlg = konto.dialogs.modal({
                    title: "Dohvaćanje datoteke",
                    content: "Molimo pričekajte."
                });
            },
            successCallback: function () {
                if (dlg)
                    dlg.close();
            },
            failCallback: function (responseHtml, url) {
                KUtils.busy(false);
                if (dlg)
                    dlg.close();
            
                // JSON greške bi se mogle naći u HTML-u.
                var ispisan = false;
                var html = $(responseHtml);   
                try {                      
                    var json = $.parseJSON(html.text());
                    if (json && json.error) {
                        ispisan = true;
                        $.dialogGreska({
                            content: json.error
                        });
                    }
                }
                catch (e) { }
                
                if (ispisan === false) {
                    if (responseHtml == '')
                        responseHtml = "Nema podataka za zadane parametre. Provjerite i promijenite unesene parametre izvještaja.";
                     $.dialogGreska({
                        content: responseHtml
                    });
                }
            }
        });
	}
		
	function GetStudentNazivZaCert(student, tablica){
		return $.dsDirectCall({
			method: "sf/GetStudentNazivZaCert",
			params: [ student, tablica ]
		});
	}	
  		
	function KreirajIzvorniJop(Jop, VrstaPredaje, Grupa, PodnOznaka, GodinaBroj) {
		return $.dsDirectCall({ 
			method: "sf/KreirajIzvorniJop",
			params: [Jop, VrstaPredaje, Grupa, PodnOznaka, GodinaBroj]
		});
	} 
	
	function KreirajIspravakJopa(Jop, VrstaPredaje, Grupa, PodnOznaka, GodinaBroj) {
		return $.dsDirectCall({ 
			method: "sf/KreirajIspravakJopa",
			params: [Jop, VrstaPredaje, Grupa, PodnOznaka, GodinaBroj]
		});
	}
	
	function KreirajDopunuJopa(Jop, VrstaPredaje, Grupa, PodnOznaka, GodinaBroj) {
		return $.dsDirectCall({ 
			method: "sf/KreirajDopunuJopa",
			params: [Jop, VrstaPredaje, Grupa, PodnOznaka, GodinaBroj]
		});
	}
	
	function KreirajXmlJopa(Jop, VrstaPredaje) {
		return $.dsDirectCall({ 
			method: "sf/KreirajXmlJopa",
			params: [Jop, VrstaPredaje]
		});
	}
	
	/*function SetObjectAfterRadnikJop(radnik, program){
		 return $.dsDirectCall({ 
            method: "Sf/SetObjectAfterRadnikJop",
            params: [ radnik, program ]
        });
    } */ 
    
	function JopSSetAfterPolje(polje, jops, errorOverride){
		return $.dsDirectCallPost({
			method: "JopSSetAfterPolje",
			controller: "jops",
			params: [ polje ],
			data: [ jops ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
		});	
	}
	
	function MozeNoviJopS(obj, sto){
		 return $.dsDirectCall({ 
            method: "sf/MozeNoviJopS",
            params: [ obj, sto ]
        });
    } 
    
    function KopirajJop(jop){
		 return $.dsDirectCall({ 
            method: "sf/KopirajJop",
            params: [ jop ]
        });
    } 
    
	function GetZbrojniSFields(zbrojni){
		return $.dsDirectCall({
			method: "sf/GetZbrojniSFields",
			params: [ zbrojni ]
		});
	}    
	
	function ZbrojniSCopy(stavkeList){
		return $.dsDirectCall({
			method: "sf/ZbrojniSCopy",
			params: [ stavkeList ]
		});		
	}
	
	function ZbrojniSPaste(zbrojni){
		return $.dsDirectCall({
			method: "sf/ZbrojniSPaste",
			params: [ zbrojni ]
		});		
	}
	
	function ZbrojniPromjenaStatusa(zbrojniList, noviStatus, opis, izvrsiUPozadini){
		return $.dsDirectCall({
			method: "sf/ZbrojniPromjenaStatusa",
			params: [ zbrojniList, noviStatus, opis, izvrsiUPozadini ]
		});		
	}
	
	function GetZbrojniZakljucan(zbrojni){
		return $.dsDirectCall({
			method: "sf/GetZbrojniZakljucan",
			params: [ zbrojni ]
		});
	}	
	
	function ZbrojniSObrisiList(stavkeList){
		return $.dsDirectCall({
			method: "sf/ZbrojniSObrisiList",
			params: [ stavkeList ]
		});		
	}
		
	function ZbrojniImaStavke(zbrojni){
		return $.dsDirectCall({
			method: "sf/ZbrojniImaStavke",
			params: [ zbrojni ]
		});
	}
	
	function ZbrojniObrisiZbrojniIliStavke(zbrojni){
		return $.dsDirectCall({
			method: "sf/ZbrojniObrisiZbrojniIliStavke",
			params: [ zbrojni ]
		});
	}	
	
	function GetZbrojniBrisanjePitanje(zbrojni){
		return $.dsDirectCall({
			method: "sf/GetZbrojniBrisanjePitanje",
			params: [ zbrojni ]
		});
	}	
	
	function GetZbrojniBrisanjeDodatnoPitanje(zbrojni){
		return $.dsDirectCall({
			method: "sf/GetZbrojniBrisanjeDodatnoPitanje",
			params: [ zbrojni ]
		});
	}	
	
    function ZbrojniSSetAfterPolje(polje, stariPartner, zbrojniS, errorOverride){
        return $.dsDirectCallPost({
            method: "ZbrojniSSetAfterPolje",
            controller: "zbrojnis",
            params: [ polje, stariPartner ],
            data: [ zbrojniS ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                KUtils.busy(false);
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        }); 
    }
    
    function GetHRValutaTekstualnoUOdgPadezuZaGodinu(godina, padez, brojnost){
		return $.dsDirectCall({
			method: "sf/GetHRValutaTekstualnoUOdgPadezuZaGodinu",
			params: [ godina, padez, brojnost ]
		});
	}
				  		
    function ZbrojniFormiratiXMLDatoteku(zbrojni, status, datumPredaje){
		return $.dsDirectCall({
			method: "sf/ZbrojniFormiratiXMLDatoteku",
			params: [ zbrojni, status, datumPredaje ]
		});
	}	
	
	function ZbrojniPrijenos(zbrojniPrijenos, errorOverride){
		return $.dsDirectCallPost({
			method: "ZbrojniPrijenos",
			controller: "zbrojni",
			params: [],
			data: [ zbrojniPrijenos ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}	
	
    function ZbrojniMogucPrijenos(status){
		return $.dsDirectCall({
			method: "sf/ZbrojniMogucPrijenos",
			params: [ status ]
		});
	}	
	
	function ZbrojniMogucPrijenosValidacija(zbrojniPrijenos, errorOverride){
		return $.dsDirectCallPost({
			method: "ZbrojniMogucPrijenosValidacija",
			controller: "zbrojni",
			params: [],
			data: [ zbrojniPrijenos ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}		
			
	function ZbrojniPrijenosSetAfterPolje(polje, zbrojniPrijenos, errorOverride){
		return $.dsDirectCallPost({
			method: "ZbrojniPrijenosSetAfterPolje",
			controller: "zbrojni",
			params: [polje],
			data: [ zbrojniPrijenos ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
	    });	
	}	
	
    function PartnerSinkronizacija(){
		return $.dsDirectCall({
			method: "sf/PartnerSinkronizacija",
			params: [ ]
		});
	}				
					  		
} (konto.sf.api = {}));